//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapGetters } from "vuex";
import addEditRole from "@/components/Admin/RolesAndUsers/AddEditRole/adminAddEditRole.vue";
import AdminAddEditUser from "@/components/Admin/RolesAndUsers/AdminAddEditUser/AdminAddEditUser.vue";
import { convertAndFormatTimeToLocal } from "@/assets/js/appFunc";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import AQSkeleton from "@/components/Generics/AQSkeleton/AQSkeleton.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQList from "@/components/Generics/AQList/AQList.vue";
import {
    USER_TYPES, USER_STATUS, GROUP_TYPES, GROUP_STATUS
} from "./constants";
import BulkInviteModal from "./bulkInviteModal.vue";

const defaultImageUser = require("@/assets/images/user.svg");

export default {
    name: "UsersGroupsContent",
    components: {
        addEditRole,
        AdminAddEditUser,
        AQButton,
        BulkInviteModal,
        AQDropdown,
        AQSearch,
        AQEmptySearch,
        AQList,
        AQSkeleton
    },
    filters: {
        dateFormat(value) {
            return `${date.formatDate(value, "DD.MM.YYYY")} at ${date.formatDate(value, "HH:mm:ss")}`;
        },
        filterColorType(value) {
            let color = "#F2F2F2";
            if (value.status === "DISABLED") {
                color = "#07142C26";
            } else if (value.realmId || value.type === "TSAMLUSR" || value.type === "TOPENIDUSR") {
                color = "#F2BD46";
            }
            return `background-color:${color}`;
        },
        dateFormatter(dateToFormat) {
            const newData = dateToFormat ? date.formatDate(dateToFormat, APP_DATE_DOT_FORMAT).split(" ") : "";
            let responseData = "";
            if (newData) {
                const [dateD, dateT] = newData;
                responseData = `${dateD} at ${dateT}`;
            }
            return responseData;
        }
    },
    props: {
        type: {
            type: String,
            default: "USERS"
        },
        currentItemsList: {
            type: Array,
            default: () => []
        },
        appSettings: {
            type: Boolean,
            default: false
        },
        manageGroupsType: {
            type: Boolean,
            default: false
        },
        totalNumberItems: {
            type: Number,
            default: 0
        },
        activeTab: {
            type: String,
            default: ""
        },
        skeletonState: {
            type: Boolean,
            default: true
        },
        resetFilters: {
            type: Boolean,
            default: false
        },
        loadQuery: {
            type: Object,
            default: () => {}
        },
        updateList: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showDisabled: false,
            showLastLogin: false,
            nrItemsDisplayed: 5,
            itemsPayload: {
                pageSize: 20,
                pageNumber: 0,
                types: [],
                statuses: [],
                searchValue: ""
            },
            addNewUserModal: false,
            editUserModal: false,
            showGroupModal: false,
            editItemData: null,
            APP_DATE_DOT_FORMAT,
            showInviteModal: false,
            application: "application",
            resetSearchData: false,
            resetSelectedTypes: false,
            resetSelectedStatus: false,
            resetAllSelectedData: false,
            searchValue: "",
            searchTrigger: false,
            defaultTypesValue: "",
            defaultStatusesValue: "",
            persistentOpsName: ""
        };
    },
    computed: {
        ...mapGetters("admin", ["getStatusRefreshData"]),
        getFirstSelectProps() {
            return {
                options: this.checkIfTypeUsers ? USER_STATUS : GROUP_TYPES,
                isMultiselect: true,
                placeholder: this.$t("adminUsersGroups.allTypesLabel"),
                resetSelectedData: this.resetSelectedTypes || this.resetAllSelectedData,
                persistentMenuOps: this.updateList && this.persistentOpsName === "types"
            };
        },
        getSecondSelectProps() {
            return {
                options: this.checkIfTypeUsers ? USER_TYPES : GROUP_STATUS,
                isMultiselect: true,
                placeholder: this.$t("adminUsersGroups.allStatusLabel"),
                resetSelectedData: this.resetSelectedStatus || this.resetAllSelectedData,
                persistentMenuOps: this.updateList && this.persistentOpsName === "statuses"
            };
        },
        checkIfTypeUsers() {
            return this.type === "USERS";
        }
    },
    watch: {
        $route: {
            handler() {
                this.$nextTick(() => {
                    if (this.updateList) {
                        this.persistentOpsName = "";
                        this.$emit("update:updateList", false);
                    }
                });
            }
        },
        resetFilters: {
            handler(newValue) {
                this.resetAllSelectedData = newValue;
            }
        },
        getStatusRefreshData(newValue) {
            if (newValue && newValue === this.type) {
                this.itemsPayload.searchValue = this.searchValue ? this.searchValue.trim() : "";
                this.getAllItems();
                this.$store.commit("admin/setStatusRefreshData", null);
            }
        },
        activeTab: {
            handler() {
                this.resetAllSelectedData = true;
                setTimeout(() => {
                    this.resetAllSelectedData = false;
                }, 0);
                if (this.searchValue) {
                    this.searchValue = "";
                    this.resetSearchData = true;
                    this.itemsPayload.searchValue = "";
                    this.itemsPayload.pageSize = 20;
                    this.itemsPayload.pageNumber = 0;
                    this.getAllItems();
                    setTimeout(() => {
                        this.resetSearchData = false;
                    }, 0);
                }
            }
        },
        showSearch: {
            handler(newVal) {
                this.searchTrigger = newVal;
                setTimeout(() => {
                    this.searchTrigger = false;
                }, 0);
            },
            immediate: true
        },
        loadQuery: {
            handler(newVal) {
                if (newVal && Object.keys(newVal).length > 1) {
                    if (newVal.searchValue) {
                        this.$nextTick(() => {
                            this.searchTrigger = true;
                            this.searchValue = newVal.searchValue;
                        });
                    }
                    if (newVal.types) {
                        this.defaultTypesValue = newVal.types.split(",");
                    }
                    if (newVal.statuses) {
                        this.defaultStatusesValue = newVal.statuses.split(",");
                    }
                }
            },
            immediate: true
        }
    },
    deactivated() {
        this.searchValue = "";
        this.defaultTypesValue = "";
        this.defaultStatusesValue = "";
        this.resetSelectedTypes = true;
        this.resetSelectedStatus = true;
        setTimeout(() => {
            this.resetSelectedTypes = false;
            this.resetSelectedStatus = false;
        }, 0);
    },
    methods: {
        setShowOps(name) {
            if (this.updateList) {
                this.persistentOpsName = "";
                this.$nextTick(() => {
                    this.$emit("update:updateList", false);
                });
            } else {
                this.persistentOpsName = name || "";
                this.$emit("openedDropdown", !!this.persistentOpsName);
            }
        },
        convertAndFormatTimeToLocal,
        setImage(item) {
            return item.avatarPath ? `/identity/tenants/users/image/${item.id}/s` : defaultImageUser;
        },
        getItemName(item) {
            let name = "";
            if (this.checkIfTypeUsers) {
                if (item.firstName) {
                    name = item.firstName;
                }
                if (item.lastName) {
                    name = `${name} ${item.lastName}`.trim();
                }
            } else {
                name = item.name;
            }
            return name;
        },
        filterItems(data, types) {
            if (types) {
                this.itemsPayload.types = data;
            } else {
                this.itemsPayload.statuses = data;
            }
            this.itemsPayload.searchValue = this.searchValue ? this.searchValue.trim() : "";
            this.itemsPayload.pageSize = 20;
            this.itemsPayload.pageNumber = 0;
            this.getAllItems();
        },
        addEditItem(data) {
            if (this.type === "GROUPS") {
                this.showGroupModal = true;
                this.editItemData = data || null;
            } else {
                this.editUserModal = true;
                this.editItemData = data || null;
            }
        },
        searchItems(searchText) {
            if (!searchText || searchText.length > 2) {
                this.searchValue = searchText;
                this.itemsPayload.searchValue = this.searchValue ? this.searchValue.trim() : "";
                this.itemsPayload.pageSize = 20;
                this.itemsPayload.pageNumber = 0;
                this.getAllItems();
            }
        },
        getAllItems() {
            this.$emit("getNewData", { ...this.itemsPayload });
        },
        loadMoreItems() {
            if (this.itemsPayload.pageSize === 20) {
                this.itemsPayload.pageNumber += 2;
            } else {
                this.itemsPayload.pageNumber += 1;
            }
            this.itemsPayload.pageSize = 10;
            this.itemsPayload.searchValue = this.searchValue ? this.searchValue.trim() : "";
            this.$emit("loadMoreContent");
            this.getAllItems();
        },
        openInviteModal() {
            this.showInviteModal = true;
        },
        showSuccessToast(length) {
            this.$toast.showNotify({
                message: length === 1 ? this.$t("adminUsersGroups.oneInviteToastMsg") : length + this.$t("adminUsersGroups.multipleInvitesToastMsg"),
                timeout: 5000,
                type: "success"
            });
        },
        avatarPropsGroups() {
            return {
                disabled: "active",
                type: "systemType",
                customAvatar: "avatarPath"
            };
        },
        avatarPropsUsers() {
            return {
                disabled: "status",
                type: "type",
                customAvatar: "avatarPath",
                firstAvatar: { name: "realmId", value: "EXTERNAL" }
            };
        },
        badgeUsers() {
            return {
                badgeType: "type",
                firstBadge: { name: "realmId", value: "EXTERNAL" }
            };
        },
        badgeGroups() {
            return {
                badgeType: "systemType"
            };
        },
        textToDisplay() {
            return this.itemsPayload.searchValue ? this.$tc("adminUsersGroups.results", this.totalNumberItems)
                : this.$tc(`adminUsersGroups.numberItem${this.type}`, this.totalNumberItems);
        }
    }
};
